import { useState } from 'react';
import { ActionIcon } from '@mantine/core';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share';
import './ShareButtons.css';

export default function ShareButtons({ url, title }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || window.location.href;
  const shareTitle = title || document.title;

  const handleCopyLink = async () => {
    try {
        await navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div className="share-section" role="group" aria-labelledby="share-label">
      <span id="share-label" className="share-label">SHARE</span>
      <div className="share-buttons">
        <WhatsappShareButton url={shareUrl} title={shareTitle} aria-label="Share on WhatsApp">
          <WhatsappIcon size={40} round aria-hidden="true" focusable="false" />
        </WhatsappShareButton>

        <FacebookShareButton url={shareUrl} quote={shareTitle} aria-label="Share on Facebook">
          <FacebookIcon size={40} round aria-hidden="true" focusable="false" />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl} title={shareTitle} aria-label="Share on Twitter">
          <TwitterIcon size={40} round aria-hidden="true" focusable="false" />
        </TwitterShareButton>

        <ActionIcon
          variant={copied ? 'filled' : 'default'}
          color={copied ? 'green' : 'gray'}
          size={40}
          radius="xl"
          onClick={handleCopyLink}
          aria-label={copied ? 'Link copied to clipboard' : 'Copy link to clipboard'}
          title={copied ? 'Copied!' : 'Copy link'}
        >
          <span aria-hidden="true">{copied ? '✓' : '📋'}</span>
        </ActionIcon>
      </div>
    </div>
  );
}